import {trackNewsletter} from '@aboutyou/legacy-tracking-sdk';
import {useCallback} from 'react';
import {useTracking} from '../utils/utils';

export const useTrackNewsletter = () => {
  const {TrackingClient} = useTracking();

  return useCallback(
    (action: 'subscribed' | 'unsubscribed', email: string) => {
      TrackingClient.track(trackNewsletter({action, email}));
    },
    [TrackingClient],
  );
};
